import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Cexs } from "../utils/cexs";
import { Link } from "react-router-dom";
import CopyIcon from "./CopyIcon";
import { LabledAddress } from "../utils/addresss";


const AccountLabel = ({ account,shorten }: { account:string,shorten:boolean }) => {
    return <span>
        <Link to={`/account/${account}`} className="text-decoration-none">
            {LabledAddress[account]!=null ? 
            <OverlayTrigger
                  placement="top"
                  delay={{ show: 0, hide: 100 }} // Hiển thị ngay lập tức
                  overlay={
                    <Tooltip id={`tooltip-${account}`}>
                      {account}
                    </Tooltip>
                  }
                >
             <span>
                {LabledAddress[account].Logo?<><img src={LabledAddress[account].Logo} alt={LabledAddress[account].Name} className="cex-logo" width={16} /> {" "}</>:""}
                {LabledAddress[account].Name} 
            </span>
            </OverlayTrigger>
             : <>{shorten?<span>{account.substr(0, 6)}...{account.substr(-6)}</span>:<span>{account}</span>}</>}
        </Link>
        {" "}
        <CopyIcon textToCopy={account} />
    </span>
};

export default AccountLabel;
